const DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

const dateOnlyValue = (value) => {
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return null;
    return new Date(value.getFullYear(), value.getMonth(), value.getDate());
  }

  const match = DATE_PATTERN.exec(String(value || "").slice(0, 10));
  if (!match) return null;
  const [, yearValue, monthValue, dayValue] = match;
  const year = Number(yearValue);
  const month = Number(monthValue);
  const day = Number(dayValue);
  const date = new Date(year, month - 1, day);

  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }

  return date;
};

export const isDeadlineExceeded = (status, deadline, today = new Date()) => {
  if (status === "done") return false;
  const deadlineDate = dateOnlyValue(deadline);
  const currentDate = dateOnlyValue(today);
  return Boolean(
    deadlineDate && currentDate && deadlineDate.getTime() < currentDate.getTime()
  );
};

export const getDisplayedNcStatus = (status, deadline, today = new Date()) => {
  if (status === "reopen") return "reopen";
  return isDeadlineExceeded(status, deadline, today)
    ? "delai_depasse"
    : status || "open";
};
